import { render, staticRenderFns } from "./DeliveryStatsSection.vue?vue&type=template&id=541c8522&scoped=true&"
import script from "./DeliveryStatsSection.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatsSection.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStatsSection.vue?vue&type=style&index=0&id=541c8522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541c8522",
  null
  
)

export default component.exports